<template>
  <div>
    <vue-headful title="Credimóvil | Aviso de privacidad" />
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_5">
      <div class="container">
        <h6></h6>
        <h2>Términos y condiciones</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->

    <!-- Achieve your financial -->
    <section class="achieve_financial_area afa_2">
      <div class="container">
        <div class="aviso-de-privacidad-text text-justify">
          <b class="pb-3">TÉRMINOS Y CONDICIONES</b>

          <p class="pb-3">
            A todos los usuarios de CREDIMOVIL les informamos de los siguientes Términos y
            Condiciones de Uso y Privacidad, los cuales les son aplicables por el simple uso
            o acceso a cualquiera de las Páginas que integran el Sitio Web de GPI AUTO COMERCIAL
            SAPI DE C.V.. aplicables en cualquiera de los servicios ofrecidos por CREDIMOVIL.COM
            (el "Sitio WEB"), por lo que entenderemos que los acepta, y acuerda obligarse a su
            cumplimiento.
          </p>

          <p class="pb-3">
            Las partes acuerdan que el Cliente podrá expresar su consentimiento respecto al presente (contrato/términos
            y condiciones, convenio, etc.), así como tener acceso a los servicios ofrecidos por cualquiera de las
            sociedades de crédito que operan en el país mediante medios electrónicos tales como NIP.
          </p>

          <p class="pb-3">
            Autorizo expresamente a (Otorgante de Crédito), para lleve a cabo Investigaciones sobre mi comportamiento
            Crediticio en las Sociedades de Información Crediticia (SIC) que estime conveniente. Conozco la naturaleza y
            alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas
            periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados
            a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento quede bajo
            propiedad de (Otorgante de Crédito y/o SIC Consultada) para efectos de control y cumplimiento del artículo
            28 de la LRSIC."
          </p>

          <p class="pb-3">
            <b>
              En el caso de que no esté de acuerdo con los Términos y Condiciones de Uso y
              Privacidad deberá abstenerse de acceder como usuario o utilizar el Sitio Web.
            </b>
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL SAPI DE C.V.. se reservan el derecho de modificar discrecionalmente
            el contenido del Sitio Web y/o aplicación en cualquier momento, sin necesidad de previo
            aviso.
          </p>

          <p class="pb-3">
            El Usuario, entendido como aquella persona que realiza el acceso mediante equipo de
            cómputo y/o de comunicación, conviene en no utilizar dispositivos, software, o cualquier
            otro medio tendiente a interferir tanto en las actividades y/u operaciones del Sitio Web
            o en las bases de datos y/o información que se contenga en el mismo.
          </p>

          <p class="pb-3">
            CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES, LOS CUALES TIENEN EL
            CARÁCTER DE OBLIGATORIOS Y VINCULANTES, DEBERA DE ABSTENERSE DE UTILIZAR EL SITIO Y/O
            SERVICIOS OFRECIDOS POR GPI AUTO COMERCIAL SAPI DE C.V..
          </p>

          <p class="pb-3">
            El Usuario debe leer, entender y aceptar todas las condiciones establecidas en los presentes
            Términos y Condiciones y en el Aviso de Privacidad, así como en los demás documentos incorporados
            a los mismos, previo a su inscripción o registro como Usuario de CREDIMOVIL.
          </p>

          <p class="pb-3">
            <b>
              1. USO Y RESTRICCIONES
            </b>
          </p>

          <p class="pb-3">
            El acceso o utilización del Sitio Web expresa la adhesión plena y sin reservas del usuario a los
            presentes Términos y Condiciones de Uso y Privacidad. A través del sitio (www.credimovil.com),
            el Usuario (entendiéndose como cualquier persona que accese al sitio) se servirá de el y/o utilizará
            el servicio y contenidos (en lo sucesivo, "Servicios y Contenidos"), puestos a disposición de los
            Usuarios por GPI AUTO COMERCIAL SAPI DE C.V. (en lo sucesivo, " GPI AUTO COMERCIAL "), y/o por
            terceros proveedores de Servicios y Contenidos. CREDIMOVIL tendrá el derecho a negar, restringir
            o condicionar al Usuario el acceso a las Páginas, total o parcialmente, a su entera discreción, así
            como a modificar los Servicios y Contenidos de las Páginas en cualquier momento y sin necesidad de
            previo aviso.
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL SAPI DE C.V. no garantiza la disponibilidad y continuidad de la operación del
            Sitio Web y/o plataforma y de los Servicios y Contenidos, ni la utilidad del Portal o los Servicios
            y Contenidos en relación con cualquier actividad específica, independientemente del medio de acceso
            que utilice el Usuario incluido la telefonía móvil. GPI AUTO COMERCIAL. SAPI DE C.V. no será
            responsable por daño o pérdida alguna de cualquier naturaleza que pueda ser causado debido a la
            falta de disponibilidad o continuidad de operación de la Página y/o de los Servicios y Contenidos.
          </p>

          <p class="pb-3">
            <b>
              2. PROPIEDAD INTELECTUAL
            </b>
          </p>

          <p class="pb-3">
            Los derechos de propiedad intelectual respecto de los Servicios y Contenidos y los signos distintivos
            y dominios de las Páginas o el Portal, así como los derechos de uso y explotación de los mismos,
            incluyendo su divulgación, publicación, reproducción, distribución y transformación, son propiedad
            exclusiva de GPI AUTO COMERCIAL. El cliente no adquiere ningún derecho de propiedad intelectual por
            el simple uso de los Servicios y contenidos del Sitio Web y en ningún momento dicho uso será
            considerado como una autorización o licencia para utilizar los Servicios y Contenidos con fines
            distintos a los que se contemplan en los presentes Términos y Condiciones de Uso y Privacidad y
            a los contratos respectivos.
          </p>

          <p class="pb-3">
            <b>
              3. PROPIEDAD INTELECTUAL DE TERCEROS
            </b>
          </p>

          <p class="pb-3">
            El Usuario acuerda que las disposiciones que se establecen en el inciso 2 anterior respecto de la
            titularidad de los derechos de GPI AUTO COMERCIAL también son aplicables a los derechos de terceros
            respecto de los Servicios y Contenidos de las Páginas, dominios o información presentada o vinculada
            al Sitio Web.
          </p>

          <p class="pb-3">
            <b>
              4. USOS PERMITIDOS
            </b>
          </p>

          <p class="pb-3">
            El aprovechamiento de los Servicios y Contenidos del Sitio Web es exclusiva responsabilidad del Usuario,
            quien en todo caso deberá servirse de ellos acorde a las funcionalidades permitidas en la propia Página
            y a los usos autorizados en los presentes Términos y Condiciones de Uso y Privacidad, por lo que el
            Usuario se obliga a utilizarlos de modo tal que no atenten contra las normas de uso y convivencia en
            Internet, las leyes de los Estados Unidos Mexicanos y la legislación vigente en el país en que el
            Usuario se encuentre al usarlos, las buenas costumbres, la dignidad de la persona y los derechos de
            terceros. El Sitio Web es para el uso individual del Usuario por lo que no podrá comercializar de
            manera alguna los Servicios y Contenidos.
          </p>

          <p class="pb-3">
            <b>
              5. RESTRICCIONES
            </b>
          </p>

          <p class="pb-3">
            El Usuario no tiene el derecho de colocar híper ligas de y al Portal, ni el derecho de colocar o
            utilizar los Servicios y Contenidos de la Página en sitios o páginas propias o de terceros sin
            autorización previa y por escrito del GPI AUTO COMERCIAL SAPI DE C.V.. Asimismo, el Usuario no tendrá
            el derecho de limitar o impedir a cualquier otro Usuario el uso del Portal.
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL se reserva el derecho de otorgar el servicio en caso de que el Usuario no
            tenga un buen historial crediticio, información recabada de Buro de Crédito por medio de la
            información personal recabada en el sitio.
          </p>

          <p class="pb-3">
            <b>
              6. CALIDAD DE LOS SERVICIOS Y CONTENIDOS
            </b>
          </p>

          <p class="pb-3">
            Ni GPI AUTO COMERCIAL SAPI DE C.V.., ni sus proveedores o socios comerciales serán responsables de
            cualquier daño o perjuicio que sufra el Usuario a consecuencia de inexactitudes, consultas realizadas,
            asesorías, errores tipográficos y cambios o mejoras que se realicen periódicamente a los Servicios y
            Contenidos. Las recomendaciones y consejos obtenidos a través del Sitio Web son de naturaleza general,
            por lo que no deben tomarse en cuenta en la adopción de decisiones personales ni profesionales. Para
            ello se debe consultar a un profesional apropiado que pueda asesorar al Usuario de acuerdo con sus
            necesidades específicas.
          </p>

          <p class="pb-3">
            <b>
              7. BIENES Y SERVICIOS DE TERCEROS ENLAZADOS
            </b>
          </p>

          <p class="pb-3">
            El hecho de que se ofrezca información en el Sitio Web o en otros sitios ligados o vinculados, no implica
            la recomendación, garantía, patrocinio o aprobación por parte de GPI AUTO COMERCIAL SAPI DE C.V..
            respecto de dicha información, bienes y/o servicios. La disponibilidad de bienes y/o servicios ofertados
            por terceros o por sitios ligados o vinculados, no es responsabilidad de GPI AUTO COMERCIAL SAPI DE C.V..
            En vista de lo anterior, GPI AUTO COMERCIAL no será responsable ante cualquier autoridad de cualquier
            naturaleza, por cualquier asunto relacionado con la venta, consumo, distribución, entrega, disponibilidad
            o prestación de servicios con respecto de cualquiera de los bienes y/o servicios ofertados por terceros o
            por sitios ligados o vinculados a través de la página.
          </p>

          <p class="pb-3">
            Respecto de los Servicios y Contenidos que prestan terceros dentro o mediante enlaces a la Página (tales
            como ligas, banners y botones), GPI AUTO COMERCIAL. se limita exclusivamente, para conveniencia del Usuario,
            a: (i) informar al Usuario sobre los mismos, y (ii) a proporcionar un medio para poner en contacto al
            Usuario con proveedores o vendedores. Los productos y/o servicios que se comercializan dentro del Sitio
            Web y/o en los sitios de terceros enlazados son suministrados por comerciantes independientes a GPI AUTO
            COMERCIAL. No existe ningún tipo de relación laboral, asociación o sociedad, entre el GPI AUTO COMERCIAL
            y dichos terceros. Toda asesoría, consejo, declaración, información y contenido de las páginas de terceros
            enlazadas o dentro de la Sitio Web representan las opiniones y juicios de dicho tercero, consecuentemente,
            GPI AUTO COMERCIAL no será responsable de ningún daño o perjuicio que sufra el Usuario a consecuencia de
            los mismos.
          </p>

          <p class="pb-3">
            <b>
              8. CONFIDENCIALIDAD
            </b>
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL se obliga a mantener confidencial la información que reciba de cualquier persona que
            tenga el carácter de Usuario conforme a las disposiciones legales aplicables, en los Estados Unidos
            Mexicanos.
            GPI AUTO COMERCIAL no asume ninguna obligación de mantener confidencial cualquier otra información que el
            Usuario le proporcione, ya sea al inscribirse al Sitio Web o en cualquier otro momento posterior, incluyendo
            aquella información que el Usuario proporcione a través de boletines, pizarras o plática en línea (chats);
            así como, GPI AUTO COMERCIAL se obliga a mantener la confidencialidad de la información que se genere a
            través
            de las Cookies que se describen en inciso 10.
          </p>

          <p class="pb-3">
            <b>
              9. USO DE LA INFORMACIÓN NO CONFIDENCIAL
            </b>
          </p>

          <p class="pb-3">
            Mediante el uso del Portal, el Usuario autoriza a GPI AUTO COMERCIAL a utilizar, publicar, reproducir,
            divulgar,
            comunicar públicamente y/o transmitir la información no confidencial o no individual, en términos de lo
            establecido
            en el artículo 109 de la Ley Federal de los Derechos de Autor y de la fracción I, del artículo 76 bis de la
            Ley
            Federal de Protección al Consumidor.
          </p>

          <p class="pb-3">
            <b>
              10. COOKIES
            </b>
          </p>

          <p class="pb-3">
            Archivo de datos que se almacena en el disco duro del equipo de cómputo o del dispositivo de comunicaciones
            electrónicas de un Usuario al navegar en un sitio de internet específico, el cual permite intercambiar
            información
            de estado entre dicho sitio y el navegador del Usuario. La información de estado puede revelar medios de
            identificación de sesión, autenticación o preferencias del usuario, así como cualquier dato almacenado por
            el
            navegador respecto al sitio de internet.
          </p>

          <p class="pb-3">
            <b>
              11. AVISO DE PRIVACIDAD DE DATOS PERSONALES
            </b>
          </p>

          <p class="pb-3">
            Toda la información que GPI AUTO COMERCIAL recabe del Usuario será tratada con absoluta confidencialidad
            conforme las disposiciones legales aplicables.
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL no se responsabiliza por la veracidad de los Datos Personales, según dicho término se
            define en la Ley de Protección de Datos Personales…. proporcionados por sus Usuarios. Los Usuarios
            garantizan
            y se responsabilizan, en cualquier situación, de la veracidad, exactitud, vigencia y autenticidad de los
            Datos
            Personales ingresados a _______________________.
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL podrá suspender temporalmente o definitivamente a todos los Usuarios cuyos datos no
            hayan podido ser corroborados fehacientemente.
          </p>

          <p class="pb-3">
            Para conocer mayor información de la protección de sus datos personales acuda a la siguiente liga:
            <a href="https://www.credimovil.mx/" target="_blank">www.credimovil.mx</a>
          </p>

          <p class="pb-3">
            <b>
              12. CLAVES DE ACCESO
            </b>
          </p>

          <p class="pb-3">
            En todo momento, el Usuario es el responsable único y final de mantener en secreto sus claves de
            acceso con la cual tenga acceso a Servicios y Contenidos del Portal; así como a las páginas de terceros.
          </p>

          <p class="pb-3">
            <b>
              13. MODIFICACIONES
            </b>
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL tendrá el derecho de modificar en cualquier momento los Términos y Condiciones de
            Uso y Privacidad. En consecuencia, el Usuario debe leer atentamente los Términos y Condiciones de Uso y
            Privacidad cada vez que pretenda utilizar el Sitio Web. Ciertos Servicios ofrecidos a los Usuarios en
            y/o a través de la Página están sujetos a condiciones particulares propias que sustituyen, completan y/o
            modifican los presentes Términos y Condiciones de Uso y Privacidad (en lo sucesivo, las "Condiciones
            Particulares"). En consecuencia, el Usuario también debe leer atentamente las correspondientes Condiciones
            Particulares antes de acceder a cualquiera de los Servicios y Contenidos.
          </p>

          <p class="pb-3">
            De conformidad con la legislación aplicable ciertos servicios requerirán de la instalación de herramientas
            de protección para la información que se solicite, por lo que los Servicios serán negados en caso de no
            ser aceptada la instalación requerida.
          </p>

          <p class="pb-3">
            <b>
              14. MEDIOS DE PAGO
            </b>
          </p>

          <p class="pb-3">
            El Usuario acepta que por medio de Domiciliación (según este término se define en el párrafo siguiente)
            por parte de GPI AUTO COMERCIAL se le realicen los cobros por los servicios requeridos, así como intereses
            o cualquier otra comisión o cargo, en las fechas de corte que se establezcan en la solicitud al obtener el
            servicio en el sitio, GPI AUTO COMERCIAL no se hace responsable por información falsa proporcionada por el
            Usuario ni por la domiciliación de cualquier tercero.
          </p>

          <p class="pb-3">
            Domiciliación, es el cobro automático autorizado por el Usuario en el sitio web y/o plataforma al momento
            de solicitar un servicio de GPI AUTO COMERCIAL mismo que estará sujeto a la aprobación de GPI AUTO COMERCIAL
            cobro que será generado al momento de la fecha de corte del servicio solicitado incluyendo intereses o
            alguna
            otra comisión que se haya pactado al momento de la solicitud
          </p>

          <p class="pb-3">
            <b>
              15. PAGO TARDIO (CONDICIONES DE IMPAGO)
            </b>
          </p>

          <p class="pb-3">
            En caso de caer en mora en el pago del Servicio, se realizará el cobro de gastos de cobranza mismos que
            GPI AUTO COMERCIAL se reserva el derecho a determinar al momento de presentarse el supuesto, y a su vez de
            intereses moratorios.
          </p>

          <p class="pb-3">
            <b>
              16. CONDICIONES DE AUTORIZACIÓN
            </b>
          </p>

          <p class="pb-3">
            GPI AUTO COMERCIAL está facultado para negar cualquier crédito en caso de que el Usuario de que se
            trate no cumpla con un buen historial crediticio, reflejado ante el Buró de Crédito, cuyo reporte deberá
            reflejar un puntaje mayor a 530 puntos y en caso de ya contar con otros créditos con GPI AUTO COMERCIAL
            la autorización del crédito será a criterio de GPI AUTO COMERCIAL.
          </p>

          <p class="pb-3">
            <b>
              17. LEYES APLICABLES Y JURISDICCIÓN
            </b>
          </p>

          <p class="pb-3">
            Para la interpretación, cumplimiento y ejecución de los presentes Términos y Condiciones, las partes
            expresamente se someten a la jurisdicción de los tribunales competentes de la Ciudad de Guadalajara,
            Jalisco, renunciando en consecuencia a cualquier fuero que en razón de su domicilio presente o futuro
            pudieran obtener.
          </p>

          <p class="pb-3">
            <b>
              18. DOMICILIO DE GPI AUTO COMERCIAL
            </b>
          </p>

          <p class="pb-3">
            Calle Av. Las Rosas #2991 Colonia Chapalita en Guadalajara, Jalisco C.P.44510.
          </p>

          <p class="pb-3">
            <b>
              19. FINANZAS PERSONALES
            </b>
          </p>

          <p class="pb-3">
            Mantén un buen historial crediticio para que logres solicitar mayores créditos en un futuro.
          </p>

          <p class="pb-3">
            El contratar créditos por el monto mayor a tu capacidad de pago puede afectar tu historial creditico.
          </p>

        </div>
      </div>
    </section>
    <!-- Achieve your financial -->
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/TermsAndConditions.vue